module.exports = __webpack_public_path__ + "img/binance.252ecfbb.png";